import { render, staticRenderFns } from "./integralRecordStatistics.vue?vue&type=template&id=a8185d36&"
import script from "./integralRecordStatistics.vue?vue&type=script&lang=js&"
export * from "./integralRecordStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports